import React, { useLayoutEffect } from "react"
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { DEFAULT_PAGE_SIZE } from "../../../../config/constants";
import ModuleList from "../../../layout/ModuleList";
import { BUS_BODY_WORK_PATH, NEW_BUS_BODY_WORK_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import { BUS_BODY_WORK_COLUMN } from "../../../../config/columns";
import { clearBusBodyWorks, getBusesBodyWorks } from "../../../../actions/bus/BusBodyWork";

export const BusesBodywork = (
    {
  breadcrumbs,
  busesBodywork,
  loading,
  dispatchGetBusesBodywork,
  dispatchClearBusesBodywork,
}
) => {
    useLayoutEffect(()=>()=>dispatchClearBusesBodywork(), []);

    const data = busesBodywork.get('content') || [];
    const pages = busesBodywork.get('totalPages') || null;
    const defaultPageSize = busesBodywork.get('size') || DEFAULT_PAGE_SIZE;

    return (
    <ModuleList
        title="Carrocería"
        breadcrumbs={breadcrumbs}
        buttonPath={NEW_BUS_BODY_WORK_PATH}
        tableStructure={{
        columns: BUS_BODY_WORK_COLUMN,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetBusesBodywork,
        modelPath: BUS_BODY_WORK_PATH,
        loading,
        navigateToModelOnRowClick: true,
        }}
    />
    ); 
}

const mapDispatchToProps = {
  dispatchGetBusesBodywork: getBusesBodyWorks,
  dispatchClearBusesBodywork: clearBusBodyWorks,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Carrocería',
      href: BUS_BODY_WORK_PATH,
    },
  ],
  busesBodywork: BusUnit.BusBodyWork.getIn(['all', 'content']),
  loading: BusUnit.BusBodyWork.getIn(['all', 'loading']),
});

BusesBodywork.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  busesBodywork: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetBusesBodywork: PropTypes.func.isRequired,
  dispatchClearBusesBodywork: PropTypes.func.isRequired,
};

BusesBodywork.defaultProps = {
  busesBodywork: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusesBodywork);